const MITRA_PEDULI_ME_URL = '/data-poolings-me/mitra-peduli-submissions';
const MITRA_PEDULI_URL = '/v4/data-poolings/mitra-peduli-submissions';

export const getSubmissionList = $axios => $axios.$get(MITRA_PEDULI_ME_URL);
export const checkEligibility = ($axios, { type, payload }) =>
  $axios.$post(`${MITRA_PEDULI_URL}/${type}/eligibility`, payload);
